import PropTypes from 'prop-types';
import { Component } from 'react';
class FeedPostCommentMenuReport extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <div>Report Comment</div>;
	}
}

FeedPostCommentMenuReport.propTypes = {
	type: PropTypes.string.isRequired,
	types: PropTypes.object.isRequired,
	commentId: PropTypes.string.isRequired,
	setType: PropTypes.func.isRequired,
	getBadge: PropTypes.func.isRequired,
	getModal: PropTypes.func.isRequired,
};

export default FeedPostCommentMenuReport;
